import { render, staticRenderFns } from "./upload-img-button.vue?vue&type=template&id=33950647&"
import script from "./upload-img-button.vue?vue&type=script&lang=js&"
export * from "./upload-img-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports